import React from 'react';
import styled from 'styled-components';
import {
  BlueskyIcon,
  BlueskyShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  XIcon,
} from 'react-share';

import {
  CustomBskyIcon,
  CustomFacebookIcon,
  CustomLinkedinIcon,
  CustomXIcon,
} from '@/core/components/SocialMediaIcons';

import { useIsClient } from '@/utils/hooks/useIsClient';

interface IconsWrapperProps {
  customIcons: boolean;
}

const IconsWrapper = styled.div<IconsWrapperProps>`
  display: flex;

  button {
    margin-right: ${props => (props.customIcons ? '25px' : '5px')};
  }

  button:last-child {
    margin-right: 0;
  }
`;

interface ShareIconsProps {
  customIcons?: boolean;
  textcolor?: string;
  title?: string;
  uuid: string | Array<string> | undefined;
}

export const ShareIcons = ({
  customIcons,
  textcolor,
  title,
  uuid,
}: ShareIconsProps) => {
  const isClient = useIsClient();

  return (
    <IconsWrapper customIcons={!!customIcons}>
      {isClient && typeof (uuid) === 'string' && (
        <>
          <FacebookShareButton
            htmlTitle="Share this page on Facebook"
            title={title}
            url={`${window.location.origin}/${uuid}`}
          >
            {!customIcons ?
              (
                <FacebookIcon
                  borderRadius={16}
                  size={32}
                />
              ) :
              (
                <CustomFacebookIcon textcolor={textcolor || '#fff'} />
              )
            }
          </FacebookShareButton>
          <TwitterShareButton
            htmlTitle="Share this page on X (Twitter)"
            title={title}
            url={`${window.location.origin}/${uuid}`}
          >
            {!customIcons ?
              (
                <XIcon
                  borderRadius={16}
                  size={32}
                />
              ) :
              (
                <CustomXIcon textcolor={textcolor || '#fff'} />
              )
            }
          </TwitterShareButton>
          <BlueskyShareButton
            htmlTitle="Share this page on BlueSky"
            title={title}
            url={`${window.location.origin}/${uuid}`}
          >
            {!customIcons ?
              (
                <BlueskyIcon
                  borderRadius={16}
                  size={32}
                />
              ) :
              (
                <CustomBskyIcon textcolor={textcolor || '#fff'} />
              )
            }
          </BlueskyShareButton>
          <LinkedinShareButton
            htmlTitle="Share this page on LinkedIn"
            title={title}
            url={`${window.location.origin}/${uuid}`}
          >
            {!customIcons ?
              (
                <LinkedinIcon
                  borderRadius={16}
                  size={32}
                />
              ) :
              (
                <CustomLinkedinIcon textcolor={textcolor || '#fff'} />
              )
            }
          </LinkedinShareButton>
        </>
      )}
    </IconsWrapper>
  );
};

ShareIcons.defaultProps = {
  customIcons: false,
  textcolor: null,
  title: '',
};
